import Action, {GET, POST_FORM,POST} from "../common/Action";

export const getDiscountsAction = new Action('GET_DISCOUNTS', POST, 'discounts/list');

export const getDiscounts = (eventId) => getDiscountsAction.callApi(({eventId: Number(eventId)}));